import React, { useState } from 'react'
import ReportIcon from '@mui/icons-material/Report';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import {  DateRange, Home, Sell, Sensors } from '@mui/icons-material'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import SearchNot from '../../images/searchNot.png'
import EmptyReturn from '../EmptyReturn';
import useChangeFarm from '../CustomHooks/useChangeFarm';
const moment=require('moment-jalaali')

const CollectorList = ({data}) => {
    const {changeFarm}=useChangeFarm()
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
            const {createAt}=item;
                    const pbirth=moment(createAt).format('jYYYY-jMM-jDD')
            return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
                <div  className='ThemeCard' style={{maxWidth:'300px',wordSpacing:'break-all'}}>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                <span>وضعیت :</span>
                <span>{item?.isActive?'فعال':'غیرفعال'}</span>
            </div>
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                <span> کد دستگاه :</span>
                <span>{item?.deviceCode}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Home/>
                </span>
                    </div></div>
                <span>  دامداری :</span>
                <span>{item?.farmName}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span> زمان ایجاد :</span>
                <span>{pbirth}</span>
            </div>
            <Link onClick={()=>{
                        changeFarm(item.farmId)
                      }} to={`/Packets/${item.id}`} >
            <div className='btnCardDAm'>

                مشاهده جزئیات
                </div>

            </Link>
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
    </Container>
  )
}

export default CollectorList
